module.exports = __webpack_public_path__ + "static/media/suggestion_primary.888d25c2.svg";